import { JwtAxios } from '@/packaging';

export const ssgApi = {
  async GetSsgApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetSsgApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetSsgShipment(marketAccount) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetSsgShipment?&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetSsgApiShipmentAll(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetSsgApiShipmentAll?&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetSsgApiShipmentPolicy(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetSsgApiShipmentPolicy?&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetSsgApiShipmentAddr(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetSsgApiShipmentAddr?&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async GetSsgTransPolicy(body) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetSsgTransPolicy?connectionId=${body.connectionId}&marketAccount=${body.marketAccount}&marketIdx=${body.marketIdx}&marketSubIdx=${body.marketSubIdx}&placeNo=${body.placeNo}`
    );
    return responseModel;
  },
  async GetSsgReturnExchange(connectionId, marketAccount) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/GetSsgReturnExchange?connectionId=${connectionId}&marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetSSGApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetSSGApiTemplate`, model);
    return responseModel;
  },
  async SetSsgApi(model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/SetSsgApi`,
      model
    );
    return responseModel;
  },
  async GetGosiTemplate(market, marketAccount, itemMngPropClsId) {
    let url = `/Template/Market/GetGosiTemplate?market=${market}&marketAccount=${marketAccount}`;
    if (itemMngPropClsId) {
      url += `&itemMngPropClsId=${itemMngPropClsId}`;
    }
    const responseModel = await JwtAxios.get(url);
    return responseModel;
  },
  async GetGosiTemplateDetail(market, marketAccount, itemMngPropClsId) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetGosiTemplateDetail?market=${market}&marketAccount=${marketAccount}&itemMngPropClsId=${itemMngPropClsId}`
    );
    return responseModel;
  },
  async SetGosiData(model) {
    const responseModel = await JwtAxios.post(
      `/Template/Market/SetGosiData`,
      model
    );
    return responseModel;
  },
  async DeleteGosiSet(market, marketAccount, setName) {
    const responseModel = await JwtAxios.delete(
      `/Template/Market/DeleteGosiSet?market=${market}&marketAccount=${marketAccount}&setName=${encodeURIComponent(setName)}`
    );
    return responseModel;
  }
};
